import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const ReviewsContext = createContext({ reviews: [], loaded: false, refresh: () => {} });

export const ReviewsProvider = ({ children }) => {
    const [reviews, setReviews] = useState([]);
    const [loaded, setLoaded] = useState(false);

    const refresh = useCallback(async () => {
        try {
            const res = await axios.get(`${API}/reviews`, { timeout: 12000 });
            const arr = Array.isArray(res?.data?.reviews) ? res.data.reviews : [];
            setReviews(arr);
        } catch (_e) {
            /* silent */
        } finally {
            setLoaded(true);
        }
    }, []);

    useEffect(() => {
        let mounted = true;
        refresh().catch(() => { if (mounted) setLoaded(true); });
        return () => { mounted = false; };
    }, [refresh]);

    const value = useMemo(() => ({ reviews, loaded, refresh }), [reviews, loaded, refresh]);
    return <ReviewsContext.Provider value={value}>{children}</ReviewsContext.Provider>;
};

export const useReviews = () => useContext(ReviewsContext);

export default ReviewsProvider;
